import React from 'react';

interface BodyEstatusFacturasProps {
  lifnr: string;
  systemid: string;
  setSystemId: (value: string) => void;
  setLifnr: (value: string) => void;
  customBody: string;
  setCustomBody: (body: string) => void;
  selectedMethod: "LIFNR" | "Custom";
  setSelectedMethod: (method: "LIFNR" | "Custom") => void;
  selectedRequest: string;
  setSelectedRequest: (request: string) => void;
  documentReferenceId: string;
  setDocumentReferenceId: (value: string) => void;
  invoiceStatusDesc: string;
  setInvoiceStatusDesc: (value: string) => void;
  comments: string;
  setComments: (value: string) => void;
}

const BodyEstatusFacturas = ({
  lifnr,
  setLifnr,
  customBody,
  setCustomBody,
  selectedMethod,
  setSelectedMethod,
  documentReferenceId,
  setDocumentReferenceId,
  invoiceStatusDesc,
  setInvoiceStatusDesc,
  comments,
  setComments,
  systemid,
  setSystemId
}: BodyEstatusFacturasProps) => {

  // --- CLASES OPTIMIZADAS PARA ALTO CONTRASTE ---
  // Cambiamos bg-white/5 por bg-[rgb(var(--c-surface))] para que el fondo sea sólido y el texto resalte
  const inputClass = "w-full bg-[rgb(var(--c-surface))] border border-white/10 rounded-xl p-3 text-white focus:border-purple-500 focus:ring-1 focus:ring-purple-500 outline-none transition-all placeholder:text-gray-500 mb-1 mt-1";
  const labelClass = "block text-xs font-bold text-purple-400 uppercase tracking-wider mb-2 mt-4 ml-1";

  return (
    <div className="space-y-4 animate-fadeIn">
      
      {/* Selector de Método */}
      <div>
        <label className={labelClass}>Método de ingreso</label>
        <select
          className={inputClass}
          value={selectedMethod}
          onChange={(e) => setSelectedMethod(e.target.value as "LIFNR" | "Custom")}
        >
          <option value="LIFNR" className="bg-[rgb(var(--c-surface))]">📦 Datos de Factura (Campos estructurados)</option>
          <option value="Custom" className="bg-[rgb(var(--c-surface))]">⌨️ XML Manual (Pegar Body completo)</option>
        </select>
      </div>

      <div className="h-[1px] w-full bg-gradient-to-r from-transparent via-white/10 to-transparent my-6"></div>

      {selectedMethod === "LIFNR" ? (
        <div className="space-y-2 animate-slideInRight">
          
          {/* Fila 1: System ID e ID Proveedor */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className={labelClass}>System ID</label>
              <input
                type="text"
                className={inputClass}
                value={systemid}
                onChange={(e) => setSystemId(e.target.value)}
                required
                placeholder="Ej: QASCLNT123"
              />
            </div>
            <div>
              <label className={labelClass}>ID Proveedor (LIFNR)</label>
              <input
                type="text"
                className={inputClass}
                value={lifnr}
                onChange={(e) => setLifnr(e.target.value)}
                required
                placeholder="Ej: 100001234"
              />
            </div>
          </div>

          {/* Fila 2: Referencia Factura */}
          <div>
            <label className={labelClass}>Referencia de Factura (INV_DOC_NO)</label>
            <input
              type="text"
              className={inputClass}
              value={documentReferenceId}
              onChange={(e) => setDocumentReferenceId(e.target.value)}
              required
              placeholder="Ej: 01-E001-12345678"
            />
          </div>

          {/* Fila 3: Estatus */}
          <div>
            <label className={labelClass}>Estatus de la Factura</label>
            <select
              className={`${inputClass} ${
                invoiceStatusDesc === 'paid' ? 'text-green-400 font-bold' : 
                invoiceStatusDesc === 'rejected' ? 'text-red-400 font-bold' : 'text-white'
              }`}
              value={invoiceStatusDesc}
              onChange={(e) => setInvoiceStatusDesc(e.target.value)}
              required
            >
              <option value="" className="bg-[rgb(var(--c-surface))]">-- Seleccionar estatus --</option>
              <option value="paid" className="bg-[rgb(var(--c-surface))]">🟢 Paid (Pagado)</option>
              <option value="paying" className="bg-[rgb(var(--c-surface))]">🟡 Paying (En proceso de pago)</option>
              <option value="reconciled" className="bg-[rgb(var(--c-surface))]">🔵 Reconciled (Aprobado)</option>
              <option value="processing" className="bg-[rgb(var(--c-surface))]">⚪ Processing (Parqueada)</option>
              <option value="rejected" className="bg-[rgb(var(--c-surface))]">🔴 Rejected (Rechazado)</option>
              <option value="canceled" className="bg-[rgb(var(--c-surface))]">⚫ Canceled (Cancelado)</option>
            </select>
          </div>

          {/* Fila 4: Comentarios */}
          <div>
            <label className={labelClass}>Comentarios Adicionales</label>
            <textarea
              className={`${inputClass} resize-none h-24 bg-[rgb(var(--c-surface))]`}
              value={comments}
              onChange={(e) => setComments(e.target.value)}
              placeholder="Opcional: Motivo del rechazo o info de pago..."
            />
          </div>
        </div>
      ) : (
        <div className="animate-slideInRight">
          <label className={labelClass}>Cuerpo XML (SOAP Payload)</label>
          <textarea
            className={`${inputClass} font-mono text-xs h-80 bg-black/60 border-purple-500/30 text-purple-200 p-4`}
            value={customBody}
            onChange={(e) => setCustomBody(e.target.value)}
            placeholder="<soap:Envelope>...</soap:Envelope>"
            required
          />
          <p className="text-[10px] text-gray-500 mt-2 italic px-2">
            * Asegúrate de incluir los namespaces correctos para CIG.
          </p>
        </div>
      )}
    </div>
  );
};

export default BodyEstatusFacturas;